// src/components/HeaderComponents/WalletIdentityChip.jsx
// Identidad wallet en el header: "soy mi wallet". Muestra un avatar generado de
// forma determinista a partir de la dirección (identicon de gradiente, sin librería)
// + la dirección truncada. Click → perfil. Solo se usa si el usuario tiene wallet.
import React from 'react';
import './WalletIdentityChip.css';

// Avatar determinista: dos tonos derivados de la dirección → gradiente único por wallet.
function avatarStyle(address) {
  const a = address.replace(/^0x/, '');
  const hueA = parseInt(a.slice(0, 6) || '0', 16) % 360;
  const hueB = parseInt(a.slice(6, 12) || '0', 16) % 360;
  return {
    background: `linear-gradient(135deg, hsl(${hueA} 85% 55%), hsl(${hueB} 80% 45%))`,
  };
}

export default function WalletIdentityChip({ address, onClick }) {
  if (!address) return null;
  const short = `${address.slice(0, 6)}…${address.slice(-4)}`;
  return (
    <button
      type="button"
      className="wic"
      onClick={onClick}
      title={`${address} — tu identidad (autocustodia). Tocá para ver tu perfil.`}
      aria-label="Mi wallet"
    >
      <span className="wic-avatar" style={avatarStyle(address)} aria-hidden="true" />
      <span className="wic-addr">{short}</span>
    </button>
  );
}
